import { Component, OnInit, HostListener} from '@angular/core';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  experienceHighlights = [
    {
      icon: '☕',
      title: 'Premium Coffee',
      description: 'Rich flavours, carefully sourced'
    },
    {
      icon: '🍴',
      title: 'Delicious Food & Beverages',
      description: 'From light bites to hearty meals'
    },
    {
      icon: '♣',
      title: 'A Warm & Cozy Environment',
      description: 'Perfect for work, friends or family'
    },
    {
      icon: '⌖',
      title: 'Strategic Location',
      description: 'Easy to find, easy to love'
    }
  ];

  libericaExperiences = [
     {
      icon: '🍴',
      title: 'Good Food',
      description: 'Comforting flavours made to share.',
      image: '/assets/images/experience-good-food.jpg'
    },
    {
      icon: '☕',
      title: 'Coffee Ritual',
      description: 'Artisan coffee, carefully brewed.',
      image: '/assets/images/coffee-ritual.jpg'
    },
    {
      icon: '♣',
      title: 'Community',
      description: 'A welcoming space for conversations and connection.',
      image: '/assets/images/community.jpg'
    }
  ];

  menuCategories = [
  {
    title: 'Coffee',
    image: '/assets/images/coffee.jpg',
    link: '/menu',
    fragment: 'coffeeSection'
  },
  {
    title: 'Food',
    image: '/assets/images/food.jpg',
    link: '/menu',
    fragment: 'foodSection'
  },
  {
    title: 'Beverages',
    image: '/assets/images/beverages.jpg',
    link: '/menu',
    fragment: 'beveragesSection'
  },
  {
    title: 'Snacks & Desserts',
    image: '/assets/images/snacks.jpg',
    link: '/menu',
    fragment: 'snacksDessertsSection'
  }
  ];

  latestStories = [
  {
    date: '12 Aug 2025',
    title: 'Welcome to Liberica MY Hub',
    image: '/assets/images/welcome.jpg',
    link: '/news-stories/welcome-to-liberica-my-hub'
  },
  {
    date: '05 Aug 2025',
    title: 'From Farm to Cup: Our Coffee Journey',
    image: '/assets/images/farm-to-cup.jpg',
    link: '/news-stories/from-farm-to-cup'
  },
  {
    date: '28 Jul 2025',
    title: 'Behind the Scenes at Liberica MY Hub',
    image: '/assets/images/behind-liberica.jpg',
    link: '/news-stories/behind-the-scenes-at-liberica-my-hub'
  }
  ];

  constructor() { }

  // Component Lifecycle
  ngOnInit(): void {
    this.checkReveal();
  }
  // Scroll Animations
  @HostListener('window:scroll')
  onScroll(): void {
    this.checkReveal();
  }

  checkReveal(): void {
    // Selects all elements whose class attribute contains "reveal"
    const elements = document.querySelectorAll('[class*="reveal"]');
    const windowHeight = window.innerHeight;
    elements.forEach((el: any) => {
      const position = el.getBoundingClientRect().top;
      if (position < windowHeight - 100) {
        el.classList.add('active');
      }
    });
  }
}